export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                Кол-во комменатриев
  //--------------------------------------------------------------------------
  count: {
    type: Number,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx


  //--------------------------------------------------------------------------
  //                       ID к которому принадлежит комментарий
  //--------------------------------------------------------------------------
  postId: {
    type: Number,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                 Отображать упрощенный интерфейс для комментариев?
  //--------------------------------------------------------------------------
  basicView: {
    type: Boolean,
    required: false,
    default: false,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});